import { FC, PropsWithChildren } from "react";

interface Props {
  visibleClearBtn?: boolean;
  basePath?: string;
}

const SearchConditionRow: FC<PropsWithChildren<Props>> = ({
  children,
}): JSX.Element => {
  return <div className="flex flex-wrap Cloud">{children}</div>;
};
export default SearchConditionRow;
